import { changeResponsiblePersonOfMeeting, getAllMeetings, getMeetingStatusCounts, meetingHistory } from "../controllers/meetingController";




export const handleGetAllMeetings = async (options = {}) => {
  const { meetings, lastVisible, firstVisible } = await getAllMeetings(options);



  return {
    meetings,
    firstDoc: firstVisible?.id,
    lastDoc: lastVisible?.id || null,
  };
};

export const handleGetMeetingStatusCounts = async (options = {}) => {
  return await getMeetingStatusCounts(options);
};

export const handleChangeResponsiblePerson = async ( meetingId,
  newResponsiblePersonId) =>{
await changeResponsiblePersonOfMeeting( meetingId,
  newResponsiblePersonId)

    return {
      success: true,
      message: "Responsible person updated successfully.",
    };

}

export const handleMeetingHistory = async(
meetingId
)=>{
      console.log("meetRoute"+ meetingId)

      const res =  await meetingHistory({meetingId})
      return res
}
